import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import SmsProviderForm from "./components/SmsProviderForm";

import {
  useGetSmsProviderDetailQuery,
  useUpdateSmsProviderMutation,
} from "store/services/smsProviderApi";

import { useAppMeta } from "hooks";

const SmsProviderEditScreen = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "SMS Providers", path: "/app/crm/sms-provider/list" },
    { title: "Edit SMS Provider" },
  ];

  const {
    data: smsProviderDetail,
    isLoading: loadingSmsProvider,
    error,
  } = useGetSmsProviderDetailQuery(id);

  const [updateSmsProvider, { isLoading: updatingSmsProvider }] =
    useUpdateSmsProviderMutation();

  const handleUpdateSmsProvider = async (data) => {
    if (!id) {
      toast.error("SMS Provider ID is missing");
      return;
    }
    const { _id, ...formData } = data;
    try {
      await updateSmsProvider({ _id: id, ...formData }).unwrap();
      toast.success("SMS Provider successfully updated!");
      navigate(`/app/crm/sms-provider/${id}/detail`);
    } catch (err) {
      toast.error(
        err?.data?.message ?? err?.message ?? "Couldn't update SMS Provider!"
      );
    }
  };

  useAppMeta("Edit SMS Provider");

  return (
    <BreadcrumbLayout
      breadcrumbs={breadcrumbs}
      isBusy={loadingSmsProvider || updatingSmsProvider}
    >
      <BreadcrumbLayout.Error error={error} />
      <BreadcrumbLayout.Paper>
        <SmsProviderForm
          isBusy={loadingSmsProvider || updatingSmsProvider}
          smsProviderDetail={smsProviderDetail}
          onSubmit={handleUpdateSmsProvider}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default SmsProviderEditScreen;